import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from './store/app.reducer';

import { PersistenceService } from '@services/persistence.service';
import { SetConfigurationData } from './store/actions';

import SuperTokens from "supertokens-web-js";
import Session from "supertokens-web-js/recipe/session";
import ThirdParty from 'supertokens-web-js/recipe/thirdparty'
import EmailPassword from 'supertokens-web-js/recipe/emailpassword'
import EmailVerification from "supertokens-web-js/recipe/emailverification";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent {

    private persistenceService = inject(PersistenceService);

    constructor(private store: Store<AppState>) {
        this.store.dispatch(
            new SetConfigurationData(this.persistenceService.recuperarDatos())
        );

        SuperTokens.init({
            appInfo: {
                appName: "Nuvalid",
                apiDomain: "https://newnuvalid-dev.tx.puntosalud.ar",
                // apiDomain: "http://192.168.48.204:8081",
                apiBasePath: '/api/v1/nuvalid/supertokens'
            },
            recipeList: [
                Session.init({
                    tokenTransferMethod: "header" // or "cookie"
                }),
                EmailPassword.init(),
                ThirdParty.init(),
                EmailVerification.init(),
            ],
        });

    }
}
